import { tv } from '@change/ds-utils';

export const HeaderStyles = tv({
	base: 'flex flex-col gap-2 bg-[#403A49] py-2',
	variants: {
		size: {
			xsmall: 'gap-1 py-1',
			small: 'gap-1 py-1',
			medium: '',
			large: '',
		},
	},
});

export const SkeletonContainerStyles = tv({
	base: 'flex flex-row items-center justify-start gap-1.5',
	variants: {
		size: {
			xsmall: 'h-full w-full',
			small: 'px-[5px]',
			medium: 'px-2.5',
			large: 'px-3',
		},
	},
});

export const RectangleShapeStyles = tv({
	base: 'w-[117px]',
	variants: {
		size: {
			xsmall: 'h-full w-full',
			small: 'h-[3px] w-[59px]',
			medium: 'h-1.5',
			large: 'h-2',
		},
	},
});

export const StoryStepperStyles = tv({
	base: 'h-[2px]',
	variants: {
		size: {
			xsmall: 'h-px px-[7px]',
			small: 'h-px px-[7px]',
			medium: 'px-[11px]',
			large: 'px-[6.5px]',
		},
	},
});
